import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { resource } from '@util/resource';
import { DWS } from '@interfaces/dws';

@Injectable({
  providedIn: 'root'
})
export class CompanyContactsService {

  constructor() {
  }

  list(wineryId: string, filters?: CompanyContactsFilters): Observable<DWS.Page<DWS.CompanyContact>> {
    return resource('crm://company-contacts')
      .params({
        wineryId,
        ...filters
      }).get<DWS.Page<DWS.CompanyContact>>();
  }

  create(companyContact: DWS.CompanyContact): Observable<DWS.CompanyContact> {
    return resource('crm://company-contacts')
      .post<DWS.CompanyContact>(companyContact);
  }

  get(contactId: any): Observable<DWS.CompanyContact> {
    return resource('crm://company-contacts/id')
      .params({ id: contactId })
      .get<DWS.CompanyContact>();
  }

  update(companyId: number, companyContact: DWS.CompanyContact) {
    return resource('crm://company-contacts/id')
      .params({ id: companyId })
      .put(companyContact);
  }
}

export interface CompanyContactsFilters {
  name?: string;
  vat?: string;
  sdi?: string;
  fiscalCode?: string;
}